module.exports = __webpack_public_path__ + "static/media/NoTemplate.3196644b.svg";